import React from 'react'
import industry1 from '../images/industry1.png'
import industry2 from '../images/industry2.png'
import industry3 from '../images/industry3.png'
import industry4 from '../images/industry4.png'
import industry5 from '../images/industry5.png'
import industry6 from '../images/industry6.png'
import industry7 from '../images/industry7.png'
import industry8 from '../images/industry8.png'

const WeServe = () => {
    return (
        <>
            <div className='container'>
                <div className='ok' style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }} data-aos="fade-up" data-aos-offset="250" data-aos-duration="1500" mirror='true'>
                    <h3 style={{ padding: '7px', color: 'rgb(13 92 126)', marginTop:'10px' }}>INDUSTRIES WE TRANSFORM</h3>
                    <img src="https://cdn-icons-png.flaticon.com/512/6528/6528214.png" width={'50px'} height={'50px'} style={{ marginRight: '25px', marginTop: '10px' }} alt="" />
                </div>
                <div className='row' style={{marginTop:'30px'}}>
                    <div className='col' style={{textAlign:'center'}}>
                        <img src={industry1} alt="industrylogo" />
                        <h4 style={{marginTop:'15px'}}>Technology</h4>
                        <p style={{fontSize:'17px', fontFamily:'Merriweather'}}>IT/ITES, e-Commerce, Telematics, Analytics</p>
                    </div>
                    <div className='col' style={{textAlign:'center'}}>
                        <img src={industry2} alt="industrylogo" />
                        <h4 style={{marginTop:'15px'}}>Consumer</h4>
                        <p style={{fontSize:'17px', fontFamily:'Merriweather'}}>FMCG, Retail, Travel, Leisure & Entertainment</p>
                    </div>
                    <div className='col' style={{textAlign:'center'}}>
                        <img src={industry4} alt="industrylogo" />
                        <h4 style={{marginTop:'15px'}}>Services</h4>
                        <p style={{fontSize:'17px', fontFamily:'Merriweather'}}>Consumer, IT, Hospitality</p>
                    </div>
                    <div className='col' style={{textAlign:'center'}}>
                        <img src={industry3} alt="industrylogo" />
                        <h4 style={{marginTop:'15px'}}>Healthcare</h4>
                        <p style={{fontSize:'17px', fontFamily:'Merriweather'}}>MedTech, Pharma, Hospitals</p>
                    </div>
                </div>
                <div className='row' style={{marginTop:'50px'}}>
                    <div className='col' style={{textAlign:'center'}}>
                        <img src={industry5} alt="industrylogo" />
                        <h4 style={{marginTop:'15px'}}>Banking Financial Service</h4>
                        <p style={{fontSize:'17px', fontFamily:'Merriweather'}}>FinTech, Private Equity</p>
                    </div>
                    <div className='col' style={{textAlign:'center'}}>
                        <img src={industry6} alt="industrylogo" />
                        <h4 style={{marginTop:'15px'}}>Education</h4>
                        <p style={{fontSize:'17px', fontFamily:'Merriweather'}}>EdTech, Institutions</p>
                    </div>
                    <div className='col' style={{textAlign:'center'}}>
                        <img src={industry7} alt="industrylogo" />
                        <h4 style={{marginTop:'15px'}}>Infrastructure</h4>
                        <p style={{fontSize:'17px', fontFamily:'Merriweather'}}>Realty, Telecom Mining</p>
                    </div>
                    <div className='col' style={{textAlign:'center'}}>
                        <img src={industry8} alt="industrylogo" />
                        <h4 style={{marginTop:'15px'}}>Manufacturing</h4>
                        <p style={{fontSize:'17px', fontFamily:'Merriweather'}}>Automotive, Industrial, Chemicals</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WeServe
